import { Component, Mixins } from 'vue-property-decorator'
import WidgetMixin from '../../mixins/WidgetMixin'

@Component
export default class WidgetList extends Mixins(WidgetMixin) {
  private async goToItem (index: number): Promise<void> {
    const route = this.widget.route
    if (!route || !route.name) {
      return
    }
    const value = (this.dashboardData as KwixeoDashboard.ListDatas)[index]

    await this.$router.push({
      name: route?.name,
      params: {
        ...route?.parameters,
        id: String(value.id)
      }
    })
  }
}
